import React from 'react'
import pt from 'prop-types'
import noop from 'lodash/noop'
import memoWithName from '@/hocs/memoWithName'

const LogoDarkIcon = ({ onClick }) => {
  return (
    <img onClick={onClick} src="/logo.svg?v=20260528" alt="Logo" width="32" height="32" />
  )
}

LogoDarkIcon.propTypes = {
  color: pt.string,
  onClick: pt.func,
}

LogoDarkIcon.defaultProps = {
  color: null,
  onClick: noop,
}

export default memoWithName(LogoDarkIcon)
